import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Input, Row, Col } from "antd";
import { FormItem } from "Components/form";
import { DISPLAY_MODE } from "Constants";

export default function TermOfOfficeInput({
  termOfOffice,
  form,
  mode = DISPLAY_MODE.READ_ONLY,
  ...props
}) {
  const { setValue } = form;

  useEffect(() => {
    setValue("termOfOfficeScore", (termOfOffice || 0) * 5);
  }, [termOfOffice]);

  return (
    <Row gutter={16}>
      <Col xs={12}>
        <FormItem required={true} label="Değer">
          <Controller
            defaultValue={0}
            control={form.control}
            name="termOfOffice"
            as={
              <Input
                inputmode="numeric"
                readOnly={mode === DISPLAY_MODE.READ_ONLY}
              />
            }
          />
        </FormItem>
      </Col>
      <Col xs={12}>
        <FormItem label="Toplam">
          <Controller
            control={form.control}
            name="termOfOfficeScore"
            as={<Input readOnly />}
          />
        </FormItem>
      </Col>
    </Row>
  );
}
